import { IProfileOptionsResponse } from '@kcftech/prometheus-client';
import { Control, Controller } from 'react-hook-form';

import { ProfileItem, ProfileSettingDropdown, ProfileSubSection } from '../components';
import { UserSettingsFormData } from './UserProfileModal';

export type VibrationOptionsPaneProps = Readonly<{
    options: IProfileOptionsResponse;
    className?: string;
    control: Control<UserSettingsFormData>;
}>;

export function VibrationOptionsPane({
    options: { VelocityUnits, AccelerationUnits },
    className,
    control,
}: VibrationOptionsPaneProps) {
    return (
        <ProfileSubSection className={className} title="Vibration Units">
            <ProfileItem label="Velocity Units">
                <Controller
                    control={control}
                    name="profile.VelocityUnits"
                    render={({ field: { value, onChange } }) => (
                        <ProfileSettingDropdown
                            options={VelocityUnits}
                            value={
                                VelocityUnits.find((option) => option.Value === value) ??
                                VelocityUnits[0]
                            }
                            onConfirm={(value) => onChange(value.Value)}
                        />
                    )}
                />
            </ProfileItem>
            <ProfileItem label="Acceleration Units">
                <Controller
                    control={control}
                    name="profile.AccelerationUnits"
                    render={({ field: { value, onChange } }) => (
                        <ProfileSettingDropdown
                            options={AccelerationUnits}
                            value={
                                AccelerationUnits.find(
                                    (option) => option.Value === value,
                                ) ?? AccelerationUnits[0]
                            }
                            onConfirm={(value) => onChange(value.Value)}
                        />
                    )}
                />
            </ProfileItem>
        </ProfileSubSection>
    );
}
